const cardsData = [
  {
    title: '暗夜追光',
    tag: '悬疑 · 9.2分',
    desc: '一宗尘封二十年的悬案，一位执着追寻真相的刑警，层层反转直击人性深处。年度必看悬疑大作，全程高能烧脑。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20suspense%20thriller%20atmosphere%20with%20dark%20alley%20and%20single%20streetlight%2C%20mysterious%20silhouette%20figure%20in%20trench%20coat%2C%20film%20noir%20aesthetic%20with%20deep%20shadows%20and%20warm%20amber%20light%20accents%2C%20dramatic%20composition%20with%20fog%20and%20rain%20on%20pavement%2C%20professional%20cinematic%20lighting%2C%20movie%20poster%20style%20with%20elegant%20dark%20tones&width=600&height=400&seq=card-drama-01&orientation=landscape',
  },
  {
    title: '长安十二时辰',
    tag: '古装 · 9.1分',
    desc: '盛世长安暗藏危机，十二时辰内的生死较量。恢宏盛唐气象，考究服化道，每一帧都是视觉享受。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20palace%20architecture%20with%20warm%20lantern%20lights%2C%20traditional%20rooftops%20silhouetted%20against%20golden%20sunset%20sky%2C%20elegant%20historical%20costume%20drama%20aesthetic%2C%20rich%20red%20and%20gold%20color%20palette%2C%20cinematic%20wide%20shot%20of%20ancient%20cityscape%2C%20epic%20scale%20composition%20with%20atmospheric%20haze&width=600&height=400&seq=card-drama-02&orientation=landscape',
  },
  {
    title: '狂飙2026',
    tag: '刑侦 · 9.4分',
    desc: '扫黑除恶再掀风暴，二十年正邪较量。张译张颂文巅峰对决，每一个眼神都是戏，年度口碑神作。',
    img: 'https://readdy.ai/api/search-image?query=Gritty%20crime%20drama%20visual%20with%20police%20interrogation%20room%20atmosphere%2C%20harsh%20overhead%20light%20casting%20dramatic%20shadows%2C%20urban%20noir%20aesthetic%20with%20cool%20steel%20tones%20and%20warm%20accent%20light%2C%20suspenseful%20cinematic%20composition%2C%20professional%20film%20photography%20style%20with%20deep%20contrast&width=600&height=400&seq=card-drama-03&orientation=landscape',
  },
  {
    title: '与凤行',
    tag: '仙侠 · 8.9分',
    desc: '赵丽颖林更新再度携手，三界动荡中谱写动人仙侠传奇。绝美特效与深情演绎，仙侠美学新标杆。',
    img: 'https://readdy.ai/api/search-image?query=Ethereal%20fantasy%20landscape%20with%20floating%20mountains%20and%20cherry%20blossom%20petals%2C%20soft%20dreamy%20atmosphere%20with%20golden%20and%20pink%20hues%2C%20Chinese%20xianxia%20aesthetic%20with%20flowing%20silk%20robes%20and%20ancient%20temples%2C%20magical%20light%20particles%20floating%20in%20air%2C%20cinematic%20fantasy%20composition%20with%20dramatic%20clouds&width=600&height=400&seq=card-drama-04&orientation=landscape',
  },
  {
    title: '玫瑰的故事',
    tag: '都市 · 8.8分',
    desc: '刘亦菲诠释当代都市女性成长之路，从懵懂到成熟。每个女孩都能在玫瑰身上看到自己的影子。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20urban%20cityscape%20at%20golden%20hour%20with%20warm%20sunlight%20streaming%20through%20glass%20buildings%2C%20elegant%20contemporary%20lifestyle%20aesthetic%2C%20soft%20bokeh%20background%20with%20city%20lights%2C%20warm%20rose%20gold%20color%20tones%2C%20cinematic%20portrait%20composition%20style%2C%20sophisticated%20and%20romantic%20atmosphere&width=600&height=400&seq=card-drama-05&orientation=landscape',
  },
  {
    title: '大奉打更人',
    tag: '奇幻 · 8.7分',
    desc: '王鹤棣田曦薇爆笑演绎奇幻探案，轻松幽默又不失悬疑。古装奇幻与喜剧完美融合，解压神剧。',
    img: 'https://readdy.ai/api/search-image?query=Whimsical%20ancient%20Chinese%20street%20scene%20with%20colorful%20lanterns%20at%20night%2C%20playful%20mystery%20atmosphere%2C%20warm%20festival%20lights%20and%20traditional%20architecture%2C%20fantasy%20elements%20blending%20with%20historical%20setting%2C%20vibrant%20yet%20cinematic%20color%20palette%2C%20charming%20and%20lively%20composition%20with%20soft%20glowing%20details&width=600&height=400&seq=card-drama-06&orientation=landscape',
  },
  {
    title: '皓月当空',
    tag: '古装 · 8.6分',
    desc: '宫廷权谋与儿女情长交织，实力派演员倾情演绎。精致服化道搭配扣人心弦的剧情，年度古装力作。',
    img: 'https://readdy.ai/api/search-image?query=Moonlit%20ancient%20Chinese%20palace%20courtyard%20with%20elegant%20architecture%2C%20silver%20moonlight%20casting%20soft%20shadows%20through%20tree%20branches%2C%20traditional%20lanterns%20glowing%20warmly%2C%20romantic%20historical%20drama%20atmosphere%2C%20refined%20color%20palette%20of%20silver%20and%20deep%20indigo%2C%20cinematic%20night%20scene%20with%20ethereal%20mood&width=600&height=400&seq=card-drama-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-thumb-up-line"></i>
            编辑精选
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">编辑推荐</h2>
          <p className="mt-2 text-foreground-500 text-sm">资深追剧编辑精选，品质保证不踩雷</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cardsData.slice(0, 7).map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.parentElement!.style.display = 'none';
                  }}
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 flex-wrap mb-2">
                  <h3 className="font-heading text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}